import { render, staticRenderFns } from "./LiveFieldWidget.vue?vue&type=template&id=708fc6a2&scoped=true"
import script from "./LiveFieldWidget.vue?vue&type=script&lang=js"
export * from "./LiveFieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fc6a2",
  null
  
)

export default component.exports